import axios, { post, put } from 'axios';

export const CarSerieList = (params) => async (dispatch) => {
  try {
    return await axios.get(
      `${process.env.REACT_APP_BASE_URL}/api/car-series`,
      { params }
    ).then(response => {
      return Promise.resolve(response);
    }).catch( e => {
      return Promise.reject(e)
    });

  } catch (error) {

  }
};

export const CreateCarSerie = (data) => async (dispatch) => {
  try {
    return await post(
      `${process.env.REACT_APP_BASE_URL}/api/car-series`,
      data
    ).then(response => {
      return Promise.resolve(response);
    }).catch( e => {
      return Promise.reject(e)
    });

  } catch (error) {

  }
};

export const UpdateCarSerie = ({id, data}) => async (dispatch) => {
  try {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };

    return await put(
      `${process.env.REACT_APP_BASE_URL}/api/car-series/${id}`,
      data,
      config
    ).then(response => {
      return Promise.resolve(response);
    }).catch( e => {
      return Promise.reject(e)
    });

  } catch (error) {

  }
};